import React from "react";
import {
  Icon,
  Menu,
  MenuItem,
  MenuList,
  Spinner,
  Text,
  HStack,
} from "@chakra-ui/react";
import { FaFileExport } from "react-icons/fa";
import { ReportMenuButton } from "../../Shared/Components/ReportMenuButton";
import { reportToolbarStyles } from "../../Shared/Styles/reportToolbarStyles";

export default function CashFlowActions({ onExport, isExporting, texts }) {
  return (
    <Menu>
      <ReportMenuButton>
        <HStack spacing={2}>
          {isExporting ? <Spinner size="xs" /> : <Icon as={FaFileExport} />}
          <Text>{texts.reports?.export || "Export"}</Text>
        </HStack>
      </ReportMenuButton>
      <MenuList {...reportToolbarStyles.menuList}>
        <MenuItem onClick={() => onExport("PDF")} py={1} fontSize="xs">
          {texts.reports?.toPDF || "To PDF"}
        </MenuItem>
        <MenuItem onClick={() => onExport("Excel")} py={1} fontSize="xs">
          {texts.reports?.toExcel || "To Excel"}
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
